<template>
<moo-popover :close-delay="0" popper-class="fileInfo_second_container" placement="left-start" trigger="hover" v-model="visibility" @show="()=>this.onvisibale(true)" @hide="()=>this.onvisibale(false)">
    <div slot="reference"><slot></slot></div>
    <div v-if="this.contentType !== 'FOLDER'" class="fob_item" @click="() => this.selectionAction(0)">
        <svg-icon icon-class="file_visit"></svg-icon>
        <span>{{$t("访问记录#!!!#src/pages/H5/Cloud/components/popper/FileOperateBtn.vue_1")}}</span>
      </div>
      <div v-if="this.contentType !== 'FOLDER'" style="height: 4px;"></div>
      <div class="fob_item" @click="() => this.selectionAction(1)">
        <svg-icon icon-class="file_operate"></svg-icon>
        <span>{{$t("操作记录#!!!#src/pages/H5/Cloud/components/popper/FileOperateBtn.vue_1")}}</span>
      </div>
  </moo-popover>
</template>

<script lang="ts">
export default {
  name: "FileOperateBtn",
  props: {
    contentType: {
      type: String,
    },
  },
  // @ts-ignore
  emits: ["onselectionchange", "onvisibale"],
  components: {},
  data() {
    return {
      visibility: false,
    };
  },
  watch: {

  },
  computed: {

  },
  methods: {
    selectionAction(value) {
      document.querySelectorAll(".arco-trigger-popup")?.forEach((item) => item.remove());
      this.$emit("onselectionchange", value);
      this.$emit("onvisibale", false);
      this.visibility = false;
    },
    onvisibale(value) {
      this.$emit("onvisibale", value);
    }
  },
};
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
.fileInfo_second_container {
  box-sizing: border-box;
  padding: 4px !important;
  background: #FFFFFF;
  border: 1px solid #E6E8EC !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  .fob_item {
    width: 138px;
    height: 32px;
    display: flex;
    align-items: center;
    &:hover {
      background: #F4F6F9;
      border-radius: 8px;
    }

    font-weight: 400;
    font-size: 14px;
    color: #222329;
    svg {
      width: 16px;
      height: 16px;
      margin-left: 8px;
      margin-right: 8px;
    }
  }
}
</style>
